module.exports = __webpack_public_path__ + "img/roempp.4f996e17.gif";